const styles = () => ({
  root: {
    flex: '1 1 auto',
    maxWidth: 570,
    margin: '42px 0px',
    display: 'flex',
    flexDirection: 'column',
  },

  pane: {
    overflow: 'auto',
    marginRight: '34px',
  },

  description: {
    marginBottom: 30,
  },
});

export default styles;
